import React from "react";
import { NextPage } from "next";
import useIsMobile from "@src/hooks/useIsMobile";
import Template from "@app/Template/Template";
import RulesContent from "@features/rules-content/rules-content";
import { CustomHead, DEFAULT_OG_IMAGE } from "@shared/ui/CustomHead";

const RulesPage: NextPage = () => {
    const isMobile = useIsMobile();
    return (
        <Template bgColor={isMobile ? "white" : "blue"}>
            <CustomHead
                title={"Правила сервиса"}
                description={
                    "Ознакомьтесь с правилами использования нашего сервиса. Важная информация для пользователей."
                }
                robots={"index,follow"}
                openGraph={{
                    title: "Правила сервиса",
                    description:
                        "Ознакомьтесь с правилами использования нашего сервиса. Важная информация для пользователей.",
                    type: "website",
                    image: {
                        url: DEFAULT_OG_IMAGE,
                        width: 1200,
                        height: 630,
                        alt: "Правила сервиса"
                    }
                }}
            />
            <RulesContent />
        </Template>
    );
};

export default RulesPage;